import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  pure: true
})
export class OrderByPipe implements PipeTransform {

  transform(
    value: any[],
    property: string,
    reverse: boolean = false
  ): any[] {

    if (!Array.isArray(value)) {
      return value;
    }

    if (!property) {
      return value;
    }

    const result = [...value].sort((a: any, b: any) => {

      const valueA = a?.[property];
      const valueB = b?.[property];

      if (valueA == null && valueB == null) {
        return 0;
      }

      if (valueA == null) {
        return 1;
      }

      if (valueB == null) {
        return -1;
      }

      if (
        typeof valueA === 'number' &&
        typeof valueB === 'number'
      ) {
        return valueA - valueB;
      }

      return String(valueA).localeCompare(
        String(valueB),
        undefined,
        {
          numeric: true,
          sensitivity: 'base'
        }
      );
    });

    return reverse ? result.reverse() : result;
  }
}